<script>
  import { onDestroy } from 'svelte';
  import { formatDuration } from '../../utils/relative-time';

  export let row;

  let now = Date.now(),
    timer;

  function setupTimer(running) {
    clearTimeout(timer);

    if (running) {
      now = Date.now();
      scheduleTick();
    }
  }

  function scheduleTick() {
    const delay = 1000 - ((Date.now() - startTime) % 1000);
    timer = setTimeout(() => {
      now = Date.now();
      scheduleTick();
    }, delay);
  }

  onDestroy(() => clearTimeout(timer));

  $: taskIsRunning = row.status === 'running';
  $: startTime = new Date(row.createdAt).getTime();
  $: executionRunTime = new Date(row.updatedAt).getTime() - startTime;
  $: displayedRunTime = taskIsRunning ? now - startTime : executionRunTime;

  $: setupTimer(taskIsRunning);
</script>

{#if displayedRunTime >= 1000 || taskIsRunning}
  <span class="duration" class:running={taskIsRunning}>
    {#if taskIsRunning}<span class="live-dot" aria-hidden="true" />{/if}
    {formatDuration(displayedRunTime)}
  </span>
{:else}
  <em>Immediate</em>
{/if}

<style>
  .duration {
    font-family: ui-monospace, 'SF Mono', SFMono-Regular, Menlo, Consolas, 'Liberation Mono', monospace !important;
    font-size: 0.75rem;
  }

  .duration.running {
    display: inline-flex;
    align-items: center;
    gap: var(--cds-spacing-02);
    color: var(--cds-inverse-support-02);
    font-weight: 600;
    user-select: none;
  }

  .live-dot {
    width: 0.5em;
    height: 0.5em;
    border-radius: 50%;
    background-color: currentColor;
    animation: live-pulse 1.5s ease-in-out infinite;
  }

  @keyframes live-pulse {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.3;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .live-dot {
      animation: none;
    }
  }
</style>
